module.exports = __webpack_public_path__ + "static/32-c847e7355be33634015aa21b1c04b24c.png";